export default "__VITE_ASSET__CfRRA4M7__"